import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAiP0tMYInxGhfKyKM27RCfHWFZX2C2YFs",
    authDomain: "kommunalportal-dev.firebaseapp.com",
    databaseURL: "https://kommunalportal-dev.firebaseio.com",
    projectId: "kommunalportal-dev",
    storageBucket: "kommunalportal-dev.appspot.com",
    messagingSenderId: "307649185332",
    appId: "1:307649185332:web:3efd29529805d4d705ec61"
};

const prodFirebaseConfig = {
    apiKey: "AIzaSyAEw_igQ-KwvaYeiv9IflV9t4pvurB2tdM",
    authDomain: "kommunalportal.firebaseapp.com",
    databaseURL: "https://kommunalportal.firebaseio.com",
    projectId: "kommunalportal",
    storageBucket: "kommunalportal.firebasestorage.app",
    messagingSenderId: "618130307461",
    appId: "1:618130307461:web:de3f4fba9f93ec12046cec"
}

function getFirebaseConfig() {
    switch (process.env.NODE_ENV) {
        case "production":
            return prodFirebaseConfig;
        default:
            return firebaseConfig;
    }
}
const app = firebase.initializeApp(getFirebaseConfig());

const db = firebase.firestore(app);

export default {
    db
}
